import qs from "qs";
import { singleton } from "tsyringe";
import { ManagementClient } from "../../lib/management-api.client";
import { IPage } from "../../types/api";
import { ITenant } from "../tenants/types";
import { ITenantSearchRequest } from "./types";

@singleton()
export class AdminService {
  constructor(private readonly managementClient: ManagementClient) {}

  async getTenantsPage(
    params: ITenantSearchRequest,
    continuationToken?: string,
    signal?: AbortSignal
  ) {
    const { data, headers } = await this.managementClient.get<IPage<ITenant>>(
      "/api/v1/admin/tenants-list",
      {
        params: {
          term: params.term
        },
        paramsSerializer: (params) => {
          return qs.stringify(params);
        },
        signal,
        headers: {
          "x-continuation-token": continuationToken
        }
      }
    );
    return {
      ...data,
      results: data.results.map((d) => ({
        ...d,
        trashedAt: d.trashedAt ? new Date(d.trashedAt) : undefined
      })),
      continuationToken: headers["x-continuation-token"] as string
    };
  }
}
